import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

import { NotifierComponent } from "../components/notifier/notifier.component";

@Injectable({
  providedIn: "root",
})
export class NotifierService {
  constructor(private snackBar: MatSnackBar) {}
  showNotification(headerMessage: string, bodyMessage: string, buttonText: string, link: string) {
    this.snackBar.openFromComponent(NotifierComponent, {
      data: {
        header: headerMessage,
        message: bodyMessage,
        buttonText: buttonText,
        link: link,
      },
      duration: 5000,
      horizontalPosition: "end",
      verticalPosition: "top",
      panelClass: "snack-bar-info",
    });
  }
}
